import React, { useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";

import { sumObjectValues } from "lib/common";

import {
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useSetRecoilState,
} from "recoil";
import {
  asyncGetAspectList,
  asyncGetDashboardSummary,
  asyncGetThreadList,
  currentSelected,
  currentThreadSelected,
  threadResultsType,
} from "lib/store/dashboard";
import { currentProject } from "lib/store/project";

import { Box, TabSlider, Symbol } from "@atsent/components";

import { HeaderNSidebar } from "components/template/HeaderNSidebar";
import { DashboardDateToolbar } from "components/atom/DashboardDateToolbar";
import { ThreadItem } from "components/atom/TreadList/ThreadItem";
import { DashboardChart } from "components/atom/DashboardChart";
import { DashboardItem } from "components/atom/DashboardItem";
import { WordCloud } from "components/atom/WordCloud";
import { DashboardSentimentSummary } from "components/atom/DashboardSentimentSummary";
import { SentimentIcons } from "components/atom/SentimentIcons";

import "./DashboardPage.scss";

export const DashboardPage: React.FC = () => {
  const { state, contents } = useRecoilValueLoadable(asyncGetDashboardSummary);
  const [threadList, setThreadList] = useRecoilStateLoadable(
    asyncGetThreadList(1)
  );
  const pid = useRecoilValue(currentProject);
  const aspectList = useRecoilValueLoadable(asyncGetAspectList);

  const [tab, setTab] = useState<"day" | "week" | "month">("day");
  const currentSelectedState = useRecoilState(currentSelected);
  const setCurrentSelected = useSetRecoilState(currentThreadSelected);

  //TODO : threadList랑 합쳐서 하나로 묶기ㅇㅇ
  useLayoutEffect(() => {
    if (
      threadList.state === "hasValue" &&
      threadList.contents.results.length > 0
    ) {
      currentSelectedState[1](() => ({ ...threadList.contents.results[0] }));
      setCurrentSelected(() => ({ ...threadList.contents.results[0] }));
      setThreadList(threadList.contents);
    }

    // eslint-disable-next-line
  }, [threadList.state]);

  return (
    <HeaderNSidebar cx={"DashboardPage"}>
      <DashboardDateToolbar cx={"SelectDate align-center"} />
      <DashboardItem
        cx={"Item1"}
        title={"Items"}
        list={
          state === "hasValue"
            ? Object.keys(contents).map((text) => ({
                text,
                value: sumObjectValues(contents[text]),
              }))
            : null
        }
      />
      <DashboardItem
        cx={"Item2"}
        title={"Positive"}
        list={
          aspectList.state === "hasValue"
            ? aspectList.contents?.map(({ aspect, positive }) => ({
                text: aspect,
                value: positive,
              }))
            : null
        }
      />
      <DashboardItem
        cx={"Item3"}
        title={"Negative"}
        list={
          aspectList.state === "hasValue"
            ? aspectList.contents?.map(({ aspect, negative }) => ({
                text: aspect,
                value: negative,
              }))
            : null
        }
      />
      <Box cx={"Thread no-padding"}>
        <div className="header">
          <span className="title">글타래</span>
          <Link to={`/${pid}/thread`}>More</Link>
        </div>
        {threadList.state === "hasValue" && (
          <>
            {threadList.contents.results.length === 0 ? (
              <div className="empty">
                <Symbol />
                <span>데이터가 없습니다.</span>
              </div>
            ) : (
              <div className="scroll-wrapper">
                {threadList.contents.results.map(
                  ({ ...data }: threadResultsType) => (
                    <ThreadItem
                      currentState={currentSelectedState}
                      data={data}
                      text={data.plain_text}
                      date={data.created_at}
                      id={data.idx}
                      key={`threadItem-${data.idx}`}
                      expend
                    />
                  )
                )}
              </div>
            )}
          </>
        )}
      </Box>
      <Box cx={"sentiment-box "}>
        <div className="header">
          <span className="title">Sentiment Summary</span>
          <SentimentIcons />
        </div>
        <DashboardSentimentSummary />
      </Box>
      <WordCloud />
      <Box cx={"Graph"}>
        <div className="header">
          <span className="title">분석 현황</span>
          <TabSlider
            cx={"white small"}
            name={"current"}
            handleSetData={setTab}
            list={[
              {
                value: "day",
                text: "일별",
              },
              {
                value: "week",
                text: "주별",
              },
              {
                value: "month",
                text: "월별",
              },
            ]}
          />
        </div>
        <div className="dashboard-wrapper">
          <DashboardChart unit={tab} />
        </div>
      </Box>
    </HeaderNSidebar>
  );
};
